const root = '/platform/api/'

export const IS_MOCK = false
export const API_BASE_URL = IS_MOCK ? '/mock/' : (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' + root : 'https://8r9r.com' + root)
export const TOKEN_KEY = 'X-Nideshop-Token'
export const CHAT_TOKEN_KEY = 'CHAT-Token'
export const HISTORY_KEY = 'History-Key'


// WEBPACK FOOTER //
// ./src/config/app.js